import { AntDesign } from '@expo/vector-icons';
import styled from 'styled-components/native';

export default styled(AntDesign).attrs({ name: 'arrowleft', size: 16 })`
  color: #fff;
`;
